export enum ActiveComponent {
  NONE = "NONE",
  AVAILABLE_BILLBOARDS = "AVAILABLE_BILLBOARDS",
  COMPPANY_CONTRACT = "COMPPANY_CONTRACT",
  SPATIAL_SEARCH = "SPATIAL_SEARCH",
  CONTRACTS_IN_DEPT = "CONTRACTS_IN_DEPT",
  FINANTIAL_ANALYSIS = "FINANTIAL_ANALYSIS",
}
